import { useSearchParams } from "react-router-dom";

import { ViolationMaintenancePanel } from "../../../components/network/ViolationMaintenancePanel";
import { WorkspaceTabs } from "../../../components/ui/WorkspaceTabs";
import { t } from "../../../lib/i18n";
import { ViolationsPage } from "../../violations/ViolationsPage";
import { NetworkEventsTab } from "./NetworkEventsTab";
import {
  DestinationsBucketsTab,
  DevicesBucketsTab,
  RulesBucketsTab,
} from "./ViolationsBucketsTab";
import { ViolationsTimelineTab } from "./ViolationsTimelineTab";

const PIVOT_VALUES = [
  "destinations",
  "devices",
  "rules",
  "timeline",
  "raw-events",
  "all-events",
  "maintenance",
] as const;
type PivotKey = (typeof PIVOT_VALUES)[number];

export function ViolationsWorkspace() {
  const [params] = useSearchParams();
  const raw = params.get("pivot") ?? "destinations";
  const active = (PIVOT_VALUES as readonly string[]).includes(raw)
    ? (raw as PivotKey)
    : "destinations";

  const tabs = PIVOT_VALUES.map((value) => ({
    value,
    label: t(`insights.violations.pivot.${value}`),
  }));

  return (
    <div className="stack">
      <WorkspaceTabs<PivotKey>
        tabs={tabs}
        value={active}
        useQueryParam
        queryParamName="pivot"
        ariaLabel={t("insights.violations.pivotAriaLabel")}
      />

      {active === "destinations" && <DestinationsBucketsTab />}
      {active === "devices" && <DevicesBucketsTab />}
      {active === "rules" && <RulesBucketsTab />}
      {active === "timeline" && <ViolationsTimelineTab />}
      {active === "raw-events" && <ViolationsPage />}
      {active === "all-events" && <NetworkEventsTab />}
      {active === "maintenance" && <ViolationMaintenancePanel />}
    </div>
  );
}
